import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { RxHamburgerMenu } from "react-icons/rx";
import { TbX } from 'react-icons/tb';

const Nav = () => {
    const [open, setOpen] = useState(false)

    const handleToggle = () => {
        setOpen(!open)
    }
    return (
        <div className='flex relative flex-row z-[500] w-full py-4 justify-between items-center text-[#FFFFFF]'>
            <Link to='/'>
                <img width={150} src="/Blockfarm/logo.svg" alt="" />
            </Link>
            <div className='text-[17px]  lg:flex  lg:flex-row hidden gap-10'>
                <Link to='/'>Home</Link>
                <Link to='/about'>About</Link>
                <Link to='/shop'>Shop</Link>
                <Link to='/hosting'>Hosting</Link>
                <Link to='/faq'>FAQ</Link>
                <Link to='/contact'>Contact Us</Link>
            </div>
            <Link to='/getstarted' className='lg:flex hidden flex-row items-center gap-2'>
                <p className='flex font-semibold'>Get Started</p>
                <div className='flex started p-3 rounded-lg'>
                    <img width={25} height={25} src="/Blockfarm/started.svg" alt="" />
                </div>
            </Link>
            <RxHamburgerMenu onClick={handleToggle} className='lg:hidden block text-3xl' />

            {
                open && (
                    <div className='bg-black h-[100vh] z-[50000] w-full fixed left-0 top-0 p-3 '>
                        <div className='flex flex-row w-full justify-between items-center'>
                            <img width={100} src="/Blockfarm/logo.svg" alt="" />
                            <TbX onClick={handleToggle} className='text-3xl text-white' />
                        </div>
                        <div className='flex flex-col items-center text-white gap-4'>
                            <Link to='/'>Home</Link>
                            <Link to='/about'>About</Link>
                            <Link to='/shop'>Shop</Link>
                            <Link to='/hosting'>Hosting</Link>
                            <Link to='/faq'>FAQ</Link>
                            <Link to='/contact'>Contact Us</Link>
                        </div>
                    </div>
                )
            }
        </div>
    )
}

export default Nav